import React from 'react';
import { IconBrandWhatsapp, IconCheck, IconPhone } from '@tabler/icons-react';
import {
  ActionIcon,
  Button,
  Group,
  SimpleGrid,
  Text,
  Textarea,
  TextInput,
  Title,
  Notification,
} from '@mantine/core';
import { ContactIconsList } from './ContactIcons';
import classes from './ContactUs.module.css';

const social = [
  { link: 'https://wa.me/8138924955', label: 'WhatsApp', ariaLabel: "WhatsApp", icon: IconBrandWhatsapp },
  { link: 'tel:8138924955', label: '+52 81-3892-4955', ariaLabel: "Teléfono", icon: IconPhone },
  { link: 'tel:9845559929', label: '+52 98-4555-9929', ariaLabel: "Teléfono", icon: IconPhone },
];

export function ContactUs() {
  const icons = social.map((item, index) => (
    <ActionIcon
      role="link"
      key={index}
      size={28}
      className={classes.social}
      variant="light"
      component="a"
      href={item.link}
      aria-label={item.ariaLabel}
    >
      <item.icon size={20} />
    </ActionIcon>
  ));

  const formRef = React.useRef(null);
  const [formValues, setFormValues] = React.useState({
    email: '',
    phone: '',
    name: '',
    message: '',
  });

  const [isLoading, setIsLoading] = React.useState(false);
  const [showNotification, setShowNotification] = React.useState(false);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    setIsLoading(true);
    const formData = new FormData(formRef.current as any);

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formData as any).toString(),
    })
      .then(() => {
        setShowNotification(true);
        setTimeout(() => setShowNotification(false), 5000);
        setFormValues({
          email: '',
          phone: '',
          name: '',
          message: '',
        });
      })
      .catch((error) => alert(error))
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <section className={classes.wrapper} id="contacto">
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing={50}>
        <div>
          <Title className={classes.title}>Contáctanos</Title>
          <Text className={classes.description} mt="sm" mb={30}>
            Deja tus datos y te contactaremos lo antes posible. Si prefieres, también puedes
            contactarnos a través de nuestros siguientes canales de comunicación.
          </Text>

          <ContactIconsList />

          <Group mt="xl">{icons}</Group>
        </div>

        <form ref={formRef} className={classes.form} name="contacto" onSubmit={handleSubmit}>
          <TextInput
            value={formValues.email}
            onChange={(e) => setFormValues({ ...formValues, email: e.target.value })}
            name="Email"
            type="email"
            autoComplete="email"
            label="Correo electrónico"
            placeholder="tu@email.com"
            required
            radius="md"
            classNames={{ input: classes.input, label: classes.inputLabel }}
          />
          <TextInput
            value={formValues.phone}
            onChange={(e) => setFormValues({ ...formValues, phone: e.target.value })}
            name="Tel"
            required
            type="text"
            label="Teléfono"
            placeholder="8888-8888"
            autoComplete="phone"
            mt="md"
            radius="md"
            classNames={{ input: classes.input, label: classes.inputLabel }}
          />
          <TextInput
            value={formValues.name}
            onChange={(e) => setFormValues({ ...formValues, name: e.target.value })}
            name="Nombre"
            required
            type="text"
            autoComplete="name"
            label="Nombre"
            placeholder="John Doe"
            mt="md"
            radius="md"
            classNames={{ input: classes.input, label: classes.inputLabel }}
          />
          <Textarea
            value={formValues.message}
            onChange={(e) => setFormValues({ ...formValues, message: e.target.value })}
            name="Mensaje"
            minLength={5}
            required
            label="Mensaje"
            placeholder="Escribe tu mensaje aquí..."
            mt="md"
            radius="md"
            classNames={{ input: classes.input, label: classes.inputLabel }}
          />
          <input type="hidden" name="form-name" value="contacto" />

          <Group justify="flex-end" mt="md">
            {<Button role="button" aria-label="enviar" className={classes.control} radius="md" type="submit" loading={isLoading}>
              Enviar
            </Button>}
          </Group>
        </form>
        <Notification
          id="notification"
          className={`${classes.notification} ${showNotification ? classes.show : ''}`}
          icon={<IconCheck size={20} />}
          color="teal"
          title="Correo enviado!"
          mt="md"
          onClose={() => setShowNotification(false)}
        >
          Gracias por contactarnos, pronto te responderemos.
        </Notification>
      </SimpleGrid>
    </section>
  );
}
